import "./polyfills";
import "./helpers/fetch-interceptor"; // Must be imported early to intercept all fetch calls
import React from "react";
import { createRoot } from "react-dom/client";

import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./DemoPages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";

const store = configureStore();
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();
